// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "/*https://rubyyagi.com/solve-slow-webpack-compilation/*/", "",{"version":3,"sources":["custom.css"],"names":[],"mappings":"AAAA,uDAAuD","file":"custom.css","sourcesContent":["/*https://rubyyagi.com/solve-slow-webpack-compilation/*/\n\n@layer components {\n  .datechk input[type=date]::-webkit-calendar-picker-indicator {\n    content: \"\\e915\";\n    @apply text-blue-500 absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none;\n  }\n}"]}]);
// Exports
module.exports = exports;
